import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import CompaniesList from '../../../components/users/companies/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface ICompaniesListPageProps {
}

const CompaniesListPage: React.FC<ICompaniesListPageProps> = (props: ICompaniesListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Companies", [
            {key: "home", icon: faHome, href: "/"},
            {key: "users", text: 'Users'},
            {key: "companies", text: 'Companies'}
        ])
    }, []);

    return <Stack>
        <CompaniesList />
    </Stack>;
};

export default CompaniesListPage;
